import { useEffect } from "react"

const useWindowEvent = (
  eventName: keyof WindowEventMap,
  func: () => any,
  options: boolean | AddEventListenerOptions = false
) => {
  if (typeof window !== `undefined`) {
    useEffect(() => {
      let scheduledAnimationFrame = false
      let requestedAnimationFrameId: number

      const onEvent = () => {
        func()
        scheduledAnimationFrame = false
      }

      const onRequestedAnimationFrame = () => {
        if (scheduledAnimationFrame) {
          return
        }

        scheduledAnimationFrame = true
        requestedAnimationFrameId = requestAnimationFrame(onEvent)
      }
      window.addEventListener(eventName, onRequestedAnimationFrame, options)
      return () => {
        window.removeEventListener(
          eventName,
          onRequestedAnimationFrame,
          options
        )
        cancelAnimationFrame(requestedAnimationFrameId)
        scheduledAnimationFrame = false
      }
    }, [func])
  }
}

export const useWindowEventWithoutRAF = (
  eventName: keyof WindowEventMap,
  func: () => any,
  options: boolean | AddEventListenerOptions = false
) => {
  if (typeof window !== `undefined`) {
    useEffect(() => {
      const onEvent = () => {
        func()
      }
      window.addEventListener(eventName, onEvent, options)
      return () => {
        window.removeEventListener(eventName, onEvent, options)
      }
    }, [func])
  }
}

export default useWindowEvent
